import { i18n } from "../../../../../boot/i18n";
import { HintsGroup } from "../Hint";

const hints = [
  {
    name: "ImportMusicxmlPiecePageHintsListen",
    hints: [
      {
        hint: i18n.t('onboardingCatalogPage.hints.listen'),
        element: "#import-piece-button-tips",
        hintPosition: "top-right"
      }
    ]
  }
] as HintsGroup[];

export default {
  hints
};